// mediaManagment/video_types

import { Media            ,
         initializedMedia } from './types';

import { Product          } from '../productManagment/types';

export interface Video extends Media
 {
  visible                  : boolean     ,
  title                    : string      ,
  shortTitle               : string      ,
  complementToTheTitle     : string      ,
  description              : string      ,
  duration                 : string      ,
  distribution             : string      ,
  production               : string      ,
  designer                 : string      ,
  copyright                : string      ,
  releaseDate              : Date | null ,
  firstUseDate             : Date | null ,
  ranking                  : number      ,
  numberOfViews            : number      ,
  imageFile                : string      ,   // Pas forcément la même que thumbnail
  videoFile                : string      ,
  originalImageFile        : string      ,   // Nom d'origine de la VIGNETTE ; celui de la vidéo est dans originalFile (Media)
  youtubeId                : string      ,
  productId                : number      ,
  computedDuration         : number      ,
  numberOfVotes            : number      ,
  relativeVotesValue       : number      ,
  numberOfViewsFromYoutube : number      ,
  commentsModeration       : number      ,   // -1 : désactivés ; sinon le niveau de l'IA qui les trie : 0 légère, 1 standard, 2 avancée, 3 manuelle
  likeCount                : number      ,
  dislikeCount             : number      ,
 }

export const initializedVideo = (): Video => (
 {
  ...initializedMedia()            ,
  visible                  : false ,
  title                    : ""    ,
  shortTitle               : ""    ,
  complementToTheTitle     : ""    ,
  description              : ""    ,
  duration                 : ""    ,
  distribution             : ""    ,
  production               : ""    ,
  designer                 : ""    ,
  copyright                : ""    ,
  releaseDate              : null  ,
  firstUseDate             : null  ,
  ranking                  : 0     ,
  numberOfViews            : 0     ,
  imageFile                : ""    ,
  videoFile                : ""    ,
  originalImageFile        : ""    ,
  youtubeId                : ""    ,
  productId                : 2     ,
  computedDuration         : 0     ,
  numberOfVotes            : 0     ,
  relativeVotesValue       : 0     ,
  numberOfViewsFromYoutube : 0     ,
  commentsModeration       : 1     ,
  likeCount                : 0     ,
  dislikeCount             : 0     ,
});

export interface VideoCategory
 {
  id      : number  ,
  name    : string  ,
  rank    : number  ,
  visible : boolean
 }

export const initializedVideoCategory = (): VideoCategory => (
 {
  id      : 0     ,
  name    : ""    ,
  rank    : 0     ,
  visible : false
});

export interface VideoCatalog
 {
  videos     : Video         [] ,
  categories : VideoCategory [] ,
  products   : Product       []
 }

export const initializedVideoCatalog = (): VideoCatalog => (
 {
  videos     : [] ,
  categories : [] ,
  products   : []
});

